import { ApiRequestOptions } from "../../../core/services/api/request-options";
import { Observable } from "rxjs/Observable";
import { Task } from "./task.model";
import { AccountObjectApiFacade } from "../account-object/account-object.api-facade";
import { ITaskFilters } from "./task.reducer";
import { IFilteredResponse } from "../../../core/services/api/filtered-response.interface";
import { isArray, isDefined } from "ionic-angular/util/util";

export class TaskApiFacade extends AccountObjectApiFacade<Task> {

    get(accountId: string, id: string, options?: ApiRequestOptions): Observable<Task> {
        return this.GET(`/accounts/${accountId}/tasks/${id}`, options)
            .map(object => new Task(object));
    }

    getAll(accountId: string): Observable<Array<Task>> {
        return this.CGET(`/accounts/${accountId}/tasks`)
            .map(objects => objects.map(object => new Task(object)));
    }

    getFiltered(accountId: string, filters: ITaskFilters, options: ApiRequestOptions = new ApiRequestOptions()): Observable<IFilteredResponse<Task>> {

        const query = {};

        if (filters.searchTerm) {
            query["filter[title]"] = filters.searchTerm;
        }

        if (isDefined(filters.done)) {
            query["filter[done]"] = filters.done;
        }

        if (filters.sortBy) {
            query[`sort[${filters.sortBy}]`] = filters.sortDirection ? "ASC" : "DESC";
        }

        if (isDefined(filters.offset)) {
            query["offset"] = filters.offset;
        }

        if (isDefined(filters.limit)) {
            query["limit"] = filters.limit;
        }

        options.setQuery(query);

        return this.api.simpleGet(`/accounts/${accountId}/tasks`, options)
            .map(response => response.json())
            .map((response: IFilteredResponse<Task>) => {

                if (isArray(response)) {
                    response = {
                        items: response,
                        total: response.length
                    };
                }

                if (!response) {
                    response = {
                        items: [],
                        total: 0
                    };
                }

                if (!response.items) {
                    console.warn("invalid response", response);
                    response = {
                        items: [],
                        total: 0
                    };
                }

                return {
                    items: response.items.map(item => new Task(item)),
                    total: response.total
                };
            });
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/task/task.api-facade.ts